import styled from "styled-components";

import { ControlledMenu } from "@szhsin/react-menu";

export const MoreButton = styled.div`
        display: ${(props) =>
            (props.$alwaysVisible || props.$open) && "flex!important"};
        -ms-flex-align: ${(props) =>
            (props.$alwaysVisible || props.$open) && "center"};
        -webkit-align-items:${(props) =>
            (props.$alwaysVisible || props.$open) && "center"};
        -webkit-box-align: ${(props) =>
            (props.$alwaysVisible || props.$open) && "center"};
        padding-left: 0px;}
    `;

export const StyledControlledMenu = styled(ControlledMenu)`
    z-index: 1000000;
`;
